// @core/api/endpoints/task/change_entity_task_status.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ChangeEntityTaskStatusRequest,
  TaskLifecycleResponse,
} from '../../../types/task';

const BASE_PATH = '/task';

/**
 * Change entity task status
 * Changes the task status of any entity with TaskAspect. Validates allowed status transitions per TaskTypeDefinition. Works for standalone tasks and domain entities (ShiftAssignment, MaintenanceRequest, etc.).
 */
export async function ChangeEntityTaskStatus(
  target_type: string,
  target_id: string,
  data: ChangeEntityTaskStatusRequest,
  options?: RequestOptions
): Promise<TaskLifecycleResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/tasks/:target_type/:target_id/status`;
  requestPath = requestPath.replace(':target_type', encodeURIComponent(target_type));
  requestPath = requestPath.replace(':target_id', encodeURIComponent(target_id));
  const requestOptions = options;
  return client.post<TaskLifecycleResponse>(requestPath, data, requestOptions);
}
